import MuiChip, { ChipProps } from '@mui/material/Chip';
import ModulEnum from 'src/enums/ModulEnum';
import { isVisible } from 'src/utils/formAuthHelper';

export interface IChipProps extends ChipProps {
  authCode?: string;
  modul?: ModulEnum;
};

const Chip = (props: IChipProps): JSX.Element => {
  const { authCode, modul, sx, ...otherProps } = props;
  return (
    isVisible(authCode, modul) && (
      <MuiChip {...otherProps} sx={{ padding: 0, ...sx }} />
    )
  );
};

export default Chip;
